<template>
	<div>
		<CModal
			:show.sync="isShow"
			:close-on-backdrop="false"
			centered
		>
			<template #header-wrapper>
				<ModalHeaderWrapper
					title="Add Page Widgets"
					@onClose="close"
				/>
			</template>
			<template #default>
				<CRow>
					<CCol>
						<FormGetPageWidget
							ref="page-widget-form"
							:selected-list="selectedList"
							@onChange="handleListChange"
						>
							<template #no-item>
								<div
									class="text-center mt-5 mb-5"
									data-test-id="no-item"
								>
									<div class="typo-body-1 font-weight-bolder color-black-45">
										Search not found
									</div>
									<div class="typo-body-2 color-black-45">
										We didn't find any page widgets matching your criteria
									</div>
								</div>
							</template>
						</FormGetPageWidget>
					</CCol>
				</CRow>
			</template>
			<template #footer>
				<BaseModalFooter
					:total-select="selectedList.length"
					@onCancel="close"
					@onConfirm="handleSubmit"
				/>
			</template>
		</CModal>
	</div>
</template>


<script>
import ModalHeaderWrapper from '@/components/ModalHeaderWrapper.vue';
import BaseModalFooter from '@/components/BaseModalFooter.vue';
import FormGetPageWidget from '@/components/FormGetPageWidget.vue';

export default {
	name: 'ModalPageWidgets',
	components: {
		ModalHeaderWrapper,
		BaseModalFooter,
		FormGetPageWidget,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			isShow: false,
			selectedList: [...this.list],
		};
	},
	methods: {
		open() {
			this.isShow = true;
			this.resetState();
		},
		close() {
			this.isShow = false;
		},
		resetState() {
			const originalList = [...this.list];
			this.selectedList = originalList;
			this.$refs['page-widget-form'].resetState(originalList);
		},
		handleListChange(list) {
			this.selectedList = list;
		},
		handleSubmit() {
			this.isShow = false;
			this.$emit('onConfirm', this.selectedList);
		},
	},
};
</script>
